import {type FunctionalComponent, h} from '@stencil/core';
import type {GuidedLinkChip} from '../api';

export interface ChipsProps{
    chips: Array<GuidedLinkChip>
}

function chip(chip) {
    const chipClass = chip.cssClass ? 'guided-chip-custom__' + chip.cssClass : '';

    return <span class={'guided-pane__suggestion-chip ' + chipClass}>
      {chip.icon ? <span class="guided-pane__suggestion-chip-icon">
        <i class="se-icon">{chip.icon}</i></span> : ''}
      {chip.label ? <span class="guided-pane__chip-label">{chip.label}:</span> : ''}
      <span class="guided-pane__chip-text">{chip.text}</span>
    </span>;
}

export const Chips:FunctionalComponent<ChipsProps> = ({chips}) => {
    return <div class="guided-pane__suggestion-chips">
      {chips.map(chipDetails => chip(chipDetails) )}
    </div>;
};
